import * as THREE from 'three';
import type { MaterialLibrary } from '../assets/MaterialLibrary';

export class Projectile {
  readonly group: THREE.Group;
  active = true;
  private readonly velocity = new THREE.Vector3();
  private readonly geometry: THREE.BufferGeometry;
  private readonly material: THREE.Material;

  constructor(
    start: THREE.Vector3,
    target: THREE.Vector3,
    speed: number,
    materials: MaterialLibrary,
    private readonly onHit: (position: THREE.Vector3) => void,
    isShell = false,
  ) {
    this.group = new THREE.Group();
    this.group.position.copy(start);

    if (isShell) {
      this.geometry = new THREE.SphereGeometry(0.08, 6, 6);
      this.material = materials.rust;
    } else {
      this.geometry = new THREE.CylinderGeometry(0.02, 0.02, 0.25, 5);
      this.material = materials.tracer;
    }

    const mesh = new THREE.Mesh(this.geometry, this.material);
    mesh.castShadow = false;
    if (!isShell) {
      mesh.rotation.x = -Math.PI / 2;
    }
    this.group.add(mesh);

    this.velocity.copy(target).sub(start);
    const distance = this.velocity.length();
    if (distance > 0.001) {
      this.velocity.normalize().multiplyScalar(speed);
      this.group.lookAt(target);
    } else {
      this.active = false;
    }
  }

  update(delta: number): void {
    if (!this.active) return;

    const step = this.velocity.clone().multiplyScalar(delta);
    this.group.position.add(step);

    if (step.length() > this.group.position.distanceTo(this.group.position.clone().add(this.velocity))) {
      // Simple arrival check is unreliable; use lifetime/distance logic in combat system.
    }
  }

  hit(): void {
    if (!this.active) return;
    this.active = false;
    this.onHit(this.group.position);
  }

  dispose(): void {
    this.geometry.dispose();
    this.group.clear();
  }
}
